__turbopack_context__.v({
  "giftcard": "GiftCard-module-scss-module__kbId7G__giftcard",
  "giftcardimage": "GiftCard-module-scss-module__kbId7G__giftcardimage",
  "giftcardtext": "GiftCard-module-scss-module__kbId7G__giftcardtext",
});
